import { useState } from 'react';
import { ArrowUpRight, Menu, X } from 'lucide-react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { Sheet, SheetTrigger, SheetPortal, SheetOverlay, SheetClose, SheetTitle, SheetDescription } from '../../components/ui/sheet';
import { useLanguage } from '../../context/LanguageContext';

export const LOGO_URL = 'https://customer-assets.emergentagent.com/job_dion-hair/artifacts/cm40t14d_DionHairClinic_Logo.svg';

export const StartNav = ({ copy }) => {
  const [open, setOpen] = useState(false);
  const { language, setLanguage } = useLanguage();
  const links = [
    ['behandlungen', copy.nav.treatments], ['techniken', copy.nav.techniques],
    ['klinik', copy.nav.clinic], ['beratung', copy.nav.consultation],
  ];
  return (
    <header className="start-header" data-testid="start-nav">
      <nav className="start-nav-inner" aria-label="Dion Hair Clinic" data-testid="start-navigation">
        <a href="#start-top" className="start-brand" data-testid="start-nav-home" aria-label="Dion Hair Clinic">
          <img src={LOGO_URL} alt="Dion Hair Clinic" width="82" height="48" data-testid="start-nav-logo" />
          <span>Dion Hair Clinic</span>
        </a>
        <div className="start-desktop-links">
          {links.slice(0, 3).map(([id, label]) => <a key={id} href={`#${id}`} data-testid={`start-nav-${id}`}>{label}</a>)}
        </div>
        <div className="start-nav-actions">
          <div className="start-language" role="group" aria-label={copy.nav.language} data-testid="start-language-selector">
            {['de', 'en'].map((lang) => (
              <button key={lang} type="button" aria-pressed={language === lang} aria-label={lang === 'de' ? 'Deutsch' : 'English'} data-testid={`start-language-${lang}`} onClick={() => setLanguage(lang)}>{lang.toUpperCase()}</button>
            ))}
          </div>
          <a href="/#kontakt" className="start-button start-button-white start-nav-cta" data-testid="start-nav-cta">{copy.nav.cta}<ArrowUpRight size={15} aria-hidden="true" /></a>
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button className="start-menu-trigger" type="button" aria-label={copy.nav.menu} data-testid="start-menu-open"><Menu size={22} aria-hidden="true" /></button>
            </SheetTrigger>
            <SheetPortal>
              <SheetOverlay className="start-menu-overlay" data-testid="start-menu-overlay" />
              <DialogPrimitive.Content className="start-mobile-menu" data-testid="start-mobile-menu">
                <div className="start-menu-top">
                  <SheetTitle className="start-menu-title" data-testid="start-menu-title">Dion Hair Clinic</SheetTitle>
                  <SheetClose asChild><button type="button" aria-label={copy.nav.close} data-testid="start-menu-close" className="start-icon-button"><X aria-hidden="true" /></button></SheetClose>
                </div>
                <SheetDescription className="sr-only" data-testid="start-menu-description">{copy.hero.fields}</SheetDescription>
                <nav aria-label={copy.nav.menu} data-testid="start-mobile-navigation">
                  {links.map(([id, label], i) => (
                    <SheetClose asChild key={id}><a href={`#${id}`} data-testid={`start-mobile-${id}`}><span className="start-mono">0{i + 1}</span>{label}<ArrowUpRight size={22} aria-hidden="true" /></a></SheetClose>
                  ))}
                </nav>
                <a href="/#kontakt" className="start-button start-button-white" data-testid="start-mobile-consultation">{copy.nav.cta}<ArrowUpRight size={17} aria-hidden="true" /></a>
                <p className="start-mono start-menu-location" data-testid="start-mobile-location">{copy.hero.location}</p>
              </DialogPrimitive.Content>
            </SheetPortal>
          </Sheet>
        </div>
      </nav>
    </header>
  );
};